<template>
  <div class="view-product-facebook-pixel">
    <step-title
      title="API de Conversões do Facebook"
      description="Crie conexões de dados fortes e seguras para maximizar o desempenho de marketing."
    />

    <div class="row my-5" v-if="integrationList.length">
      <div class="col-lg-6 d-flex align-items-center gap-3 order-1 order-lg-0">
        <span class="functional-1">Total: {{ integrationList.length }}</span>
        <bp-button
          size="md"
          color="neutral"
          variant="glyph"
          @click="dispatch"
        />
      </div>
      <div
        class="col-lg-6 d-flex flex-column flex-lg-row justify-content-lg-end"
      >
        <bp-button
          size="md"
          label="Adicionar"
          icon="fa fa-plus"
          @click="modal = true"
        />
      </div>
    </div>

    <div v-if="loading" class="text-center my-9">
      <b-spinner variant="primary" />
    </div>

    <bp-data-table v-else :data="integrationList" :columns="columns" />

    <div class="row justify-content-center" v-if="!integrationList.length">
      <div class="d-flex flex-column ">
        <span class="text-primary fs-14"
          >Para começar, adicione a primeira API de conversões do
          Facebook!</span
        >
        <div class="d-flex justify-content-center mt-3">
          <bp-button
            size="md"
            label="Adicionar API"
            icon="fa fa-plus"
            @click="modal = true"
          />
        </div>
      </div>
    </div>

    <facebook-pixel-modal
      v-model="modal"
      :integrationToEdit="integrationToEdit"
      @update-list="dispatch"
      @clear-edit="integrationToEdit = null"
    />
  </div>
</template>

<script>
import FacebookPixelModal from "@/components/product/pixel/FacebookPixelModal.vue";
import { TRANSLATE_FIELD_INTEGRATION_MAP } from "@/constants/fields.js";
import { get_error_msg } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  components: {
    FacebookPixelModal
  },
  data() {
    return {
      modal: false,
      loading: false,
      integrationToEdit: null
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", "facebook-pixel");
    this.dispatch();
  },
  computed: {
    ...mapState("integration", ["integrationList"]),
    columns() {
      return [
        {
          name: "Domínio",
          field: "domain"
        },
        {
          name: "Pixel ID",
          field: "ads_pixel_id"
        },
        {
          name: "",
          type: "menu",
          options: [
            {
              label: "Editar",
              icon: "fa-light fa-pen",
              click: this.edit
            },
            {
              label: "Excluir integração",
              class: "text-negative-600",
              icon: "fa-light fa-trash",
              dialog: {
                text: "Deseja excluir a integração?",
                buttonText: "Cancelar",
                secondaryButtonText: "Excluir",
                secondaryAction: this.submitDelete,
                icon: "fa fa-circle-exclamation"
              }
            }
          ]
        }
      ];
    }
  },
  methods: {
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", {
          product_id: this.$route.params.id
        })
        .catch(() => {
          this.$message.error("Não foi possível carregar as contas integradas");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      let data = { ...item, status: !item.status };
      this.$store
        .dispatch("integration/putIntegration", clearObject(data))
        .then(() => {
          this.$message.success(
            `Integração ${data.status ? "ativada" : "desativada"}`
          );
          this.dispatch();
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    },
    submitDelete(item) {
      this.$store
        .dispatch("integration/deleteIntegration", item.id)
        .then(() => {
          this.dispatch();
          this.$message.success("Integração removida");
        })
        .catch(error => {
          let msg = get_error_msg(
            error.response.data,
            TRANSLATE_FIELD_INTEGRATION_MAP,
            "Não foi possível deletar a conta integrada"
          );
          this.$message.error(msg);
        });
    },
    edit(item) {
      this.integrationToEdit = item;
      this.modal = true;
    }
  }
};
</script>
